import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconMapPin = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z' />
      <circle cx='12' cy='10' r='2.3' />
    </g>
  </SDIcon>
)

export default IconMapPin
